import {ChangeDetectorRef, Inject, Injectable, OnDestroy, Pipe, PipeTransform} from '@angular/core';
import {Subscription} from 'rxjs';
import {MX_TRANSLATE_SERVICE_TOKEN, MxTranslateService} from '../services/mx-translate.service';

@Pipe({
    name: 'mxTranslate',
    standalone: false,
})

@Injectable()
export class MxTranslatePipe implements PipeTransform, OnDestroy {

    private readonly languageChanged: Subscription;

    constructor(@Inject(MX_TRANSLATE_SERVICE_TOKEN) protected translateService: MxTranslateService,
                private cd: ChangeDetectorRef) {
        this.languageChanged = this.translateService.translationsChanged$
            ?.subscribe(() => this.cd.markForCheck());
    }

    transform(label: string): () => string {
        return () => this.translateService.getTranslatedLabel(label);
    }

    ngOnDestroy(): void {
        this.languageChanged?.unsubscribe();
    }
}
